<template>
  <el-scrollbar>
    <div class="scrollbar-flex-content">
      <CTable class="p-0 m-0">
        <CTableHead>
          <tr class="d-flex" :class="`d-from${info.part_item_id}`">
            <CTableDataCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'">
              <CButton
                class="btn-outline-primary text-light"
                v-if="!showChild"
                @click="showChild = !showChild"
              >
                <img src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
              <CButton
                class="btn-outline-primary text-light"
                v-else
                @click="showChild = !showChild"
              >
                <img class="openImg" src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
            </CTableDataCell>
            <CTableHeaderCell
              v-for="option in info.extension_info.cols"
              :key="option.title"
              :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
            >
              <span :class="showChild ? '' : 'invisi'">{{ option.title }}</span>
            </CTableHeaderCell>
            <CTableHeaderCell class="col-1"></CTableHeaderCell>
          </tr>
        </CTableHead>
        <CTableBody :class="showChild ? '' : 'd-none'">
          <tr
          class="d-flex"
          :class="`d-from${info.part_item_id}`"
            v-for="(row, rowIndex) in rows_items"
            :key="rowIndex"
          >
            <CTableHeaderCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"></CTableHeaderCell>
            <CTableDataCell
            :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
              v-for="(option, colIndex) in info.extension_info.cols"
              :key="colIndex"
              class="d-flex justify-content-center"
            >
              <CFormTextarea
                v-if="option.type === $defines.Part_Item_From_Type_Text"
                :disabled="+info.is_help"
                v-model="row[`answer${colIndex}`]"
                :value="
                  answerList.length
                    ? answerList[rowIndex][colIndex]
                    : ''
                "
                :key="rowIndex"
                placeholder="請填入文字 Please enter text"
                @change="emitContent($event, rowIndex, colIndex)"
                rows="3"
                style="resize: none"
              />
              <CFormInput
                v-if="option.type === $defines.Part_Item_Date_Date_Number"
                v-model="row[`answer${colIndex}`]"
                :disabled="+info.is_help"
                :value="
                answerList.length
                    ? answerList[rowIndex][colIndex]
                    : ''
                "
                type="number"
                placeholder="請填入數字 Please enter a number"
                @change="ChangeNumber($event, rowIndex, colIndex)"
                oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
              />
              <input
                v-if="option.type === $defines.Part_Item_From_Type_True_Or_False"
                type="checkbox"
                :disabled="+info.is_help"
                required
                :checked="
                  info.value_info &&
                  answerList.length &&
                  +answerList[rowIndex][colIndex] === 1
                    ? true
                    : false
                "
                v-model="row[`answer${colIndex}`]"
                @change="emitContent($event, rowIndex, colIndex)"
              />
            </CTableDataCell>
            <CTableHeaderCell class="col-1">
              <div v-if="rowIndex>0" @click="removeRowHandle(rowIndex)">
                <img
                      src="@/assets/icons/delete.svg"
                      class="me-3"
                      alt="delete"
                    />
              </div>
            </CTableHeaderCell>
          </tr>
        </CTableBody>
        <div  class="add-button" @click="moreRowHandle()">{{"增加 Add"}}</div>
      </CTable>
    </div>
  </el-scrollbar>
</template>

<script>
import { computed, ref, onMounted, watch } from '@vue/runtime-core'
import {
  Part_Item_From_Type_Text,
  Part_Item_From_Type_True_Or_False,
  Part_Item_From_Check_True,
  Part_Item_From_Check_False,
} from '../../defines'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content', 'editData'],
  setup(props, { emit }) {
    const showChild = ref(true)
    const answerList = ref([])
    const isValueInfo = ref(false)
    const rows_items = ref([1]);

    const removeRowHandle =(index)=>{
      rows_items.value.splice(index, 1)
      answerList.value.splice(index, 1)
    }

    const moreRowHandle = async ()=>{
      // if(isValueInfo.value){
        await answerList.value.push([])
        for(let v = 0; v < props.info.extension_info.cols.length; v++){
          if (
            props.info.extension_info.cols[v].type === Part_Item_From_Type_Text
          ) {
            await answerList.value[answerList.value.length-1].push('')
          } else if (
            props.info.extension_info.cols[v].type ===
            Part_Item_From_Type_True_Or_False
          ) {
            await answerList.value[answerList.value.length-1].push(Part_Item_From_Check_False)
          } else {
            await answerList.value[answerList.value.length-1].push(null)
          }
        }
      // }
      await rows_items.value.push(rows_items.value.length + '.');
      // const tr = document.querySelectorAll(`.d-from${props.info.part_item_id}`)
      // if (tr) {
      //   const trWidth = props.info.extension_info.cols.length * 250 + 'px'
      //   tr.forEach((e) => {
      //     e.style.width = trWidth
      //   })
      // }
    }

    onMounted(() => {
      // const tr = document.querySelectorAll(`.d-from${props.info.part_item_id}`)
      // if (tr) {
      //   const trWidth = props.info.extension_info.cols.length * 250 + 'px'
      //   tr.forEach((e) => {
      //     e.style.width = trWidth
      //   })
      // }
      // if( props.info.value_info && props.info.value_info.length ){
      //   for (let i = 0; i < props.info.value_info.length; i++) {
      //     rows_items.value.push(`${i}.`)
      //   }
      //   answerList.value = props.info.value_info
      // }
      if(!props.info.value_info || !props.info.value_info.length){
        for (let i = 0; i <rows_items.value.length; i++) {
          answerList.value.push([])
          for (let v = 0; v < props.info.extension_info.cols.length; v++) {
            if (
              props.info.extension_info.cols[v].type === Part_Item_From_Type_Text
            ) {
              answerList.value[i].push('')
            } else if (
              props.info.extension_info.cols[v].type ===
              Part_Item_From_Type_True_Or_False
            ) {
              answerList.value[i].push(Part_Item_From_Check_False)
            } else {
              answerList.value[i].push(null)
            }
          }
        }
      }
      emitContent()
    })
    const formList = computed(() => {
      return props.info.extension_info.rows.map((e) => {
        return String(e) === 'undefined' ? '' : String(e)
      })
    })
    const isFinish = computed(()=>{
      let state = []
      answerList.value.forEach(e=>{
        state = e.map(x=> !!x)
      })
      return state.find(e=>e === false) === undefined
    })
    const ChangeNumber = ($event, rowIndex, colIndex) => {
      if ($event?.target?.value) {
        $event.target.value = `${Number($event.target.value)}`
      }
      setTimeout(() => {
        emitContent($event, rowIndex, colIndex);
      }, 1);
    };
    const emitContent = (event, rowIndex, colIndex) => {
      if (event !== undefined) {
        if (event.target.type === 'checkbox') {
          answerList.value[rowIndex][colIndex] = event.target.checked
            ? Part_Item_From_Check_True
            : Part_Item_From_Check_False
        } else {
          answerList.value[rowIndex][colIndex] = event.target.value
        }
      }

      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: isFinish.value,
        value_info: !+props.info.is_help ? [...answerList.value] : [],
      })
    }
    watch(
      () => props.info.value_info,
      () => {
        isValueInfo.value = !!props.info?.value_info?.length
        if (props.info.value_info.length) {
          for (let i = 0; i < props.info.value_info.length -1; i++) {
            rows_items.value.push(`${i}.`)
          }
          answerList.value = props.info.value_info
        }
        // setTimeout(()=>{
        //   const tr = document.querySelectorAll(`.d-from${props.info.part_item_id}`)
        //   if (tr) {
        //     const trWidth = props.info.extension_info.cols.length * 250 + 'px'
        //     tr.forEach((e) => {
        //       e.style.width = trWidth
        //     })
        //   }
        // }, 100)
        emitContent()
      },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )

    return {
      removeRowHandle,
      moreRowHandle,
      ChangeNumber,
      emitContent,
      formList,
      showChild,
      answerList,
      isValueInfo,
      rows_items,
      isFinish
    }
  },
}
</script>
<style lang="scss" scoped>
.add-button {
  background: #177baf;
  color: #fff;
  width: 80px;
  margin: 10px 0;
  border-radius: 8px;
  padding: 5px 0;
  text-align: center;
  cursor: pointer;
  &:hover {
    background: #2e90c5;
  }
}
.remove-button {
  width: 20px;
  cursor: pointer;
}
.openImg {
  rotate: (180deg);
}

.invisi{
  visibility: hidden;
}
</style>
